import type { RouteObject } from "react-router-dom"
import { useRoutes } from "react-router-dom"
import Home from "@/pages/Home"
import Calculator from "@/pages/Calculator"
import Reviews from "@/pages/Reviews"
import ReviewDetail from "@/pages/ReviewDetail"
import Comparison from "@/pages/Comparison"
import ComparisonDetail from "@/pages/ComparisonDetail"
import Blog from "@/pages/Blog"
import BlogPost from "@/pages/BlogPost"
import Layout from "@/components/Layout"
import { allBlogPosts } from "@/data/blog"
import ReviewPageTemplate from "@/components/templates/ReviewPageTemplate"
import ComparisonPageTemplate from "@/components/templates/ComparisonPageTemplate"
import { reviewProducts } from "@/data/reviews"
import { comparisonGuides } from "@/data/comparisons"

export const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/calculator", element: <Calculator /> },
      { path: "/reviews", element: <Reviews /> },
      ...reviewProducts.map((product) => ({
        path: `/reviews/${product.slug}`,
        element: <ReviewPageTemplate product={product} />
      })),
      { path: "/reviews/:slug", element: <ReviewDetail /> },
      { path: "/comparison", element: <Comparison /> },
      ...comparisonGuides.map((guide) => ({
        path: `/comparison/${guide.slug}`,
        element: <ComparisonPageTemplate guide={guide} />
      })),
      { path: "/comparison/:slug", element: <ComparisonDetail /> },
      { path: "/blog", element: <Blog /> },
      ...allBlogPosts.map((post) => ({
        path: `/blog/${post.slug}`,
        element: <BlogPost />
      })),
      { path: "/blog/:slug", element: <BlogPost /> }
    ]
  }
]

function App() {
  return useRoutes(routes)
}

export default App
